import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { Registration } from '@/types/registration.types';
import Container from '@ui/container/container';
import Switch from '@ui/switch/switch';
import Text from '@ui/text/text/text';
import useComputedRegistrationSettings from '../../hooks/use-computed-registration-settings';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

export default function SuppressDuplicatesToggle() {
  const dispatch = useAppDispatch();
  const { courseOn, registrationSettings, passwordGateEnabled } = useComputedRegistrationSettings();
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);

  const sendEmailConfirmation = registrationSettings?.sendEmailConfirmation;
  const skipEmailOnDuplicateRegistration = registrationSettings?.skipEmailOnDuplicateRegistration;

  const toggleSuppressDuplicates = (value: boolean, on: boolean) => {
    if (!registrationSettings) return;
    const updatedSettings: Registration = {
      ...registrationSettings,
      skipEmailOnDuplicateRegistration: on,
    };

    dispatch(saveWorkingProjectByFields({ registration_settings: updatedSettings }));
  };

  return (
    <Container design="GlobalCont1" borderRadius="12px" padding="16px" className="flex ai-center jc-space-between">
      <div className="flex ai-center gap-8">
        <Text tag="h6" className="H6">
          Suppress duplicates
        </Text>
        <TooltipPortal
          tooltipContent={
            <Text>
              When disabled, registrants will receive a new confirmation email each time they submit the registration
              form.
            </Text>
          }
        >
          <Icon name={ICONS.INFO_CIRCLE} size={12} color="var(--primitives-mode-1-gray-500)" />
        </TooltipPortal>
      </div>
      <Switch
        value={!!skipEmailOnDuplicateRegistration}
        on={!!skipEmailOnDuplicateRegistration}
        onClick={toggleSuppressDuplicates}
        disabled={
          !sendEmailConfirmation || courseOn || passwordGateEnabled || !registrationSettings || savingWorkingProject
        }
      />
    </Container>
  );
}
